import React, { useCallback, useEffect, useState } from "react";
import Navbar from "../../layout/header/Header";
import "./accessManagement.scss";
import axios from "axios";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import axiosInstance from "../../httpInterceptor";
import { useNavigate } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import {
  createUserApi,
  fetchSuggestionsApi,
  getRoleApi,
  updateUserRoleApi,
} from "../../../api/services/accessManagement-apis";
import EmployeeTable, { Employee } from "../employees-list/employeesList";

const AccessManagement = () => {
  const navigate = useNavigate();
  const [input, setInput] = useState("");
  const [flag, setFlag] = useState(true);
  const [selectedList, setSelectedDetails] = useState({
    psno: "",
    email: "",
    firstName: "",
    lastName: "",
  });
  const [showDetails, setShowDetails] = useState(false);
  const [currRole, setCurrRole] = useState<any>();
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updateRole, setUpdateRole] = useState({
    psid: "",
    role: "",
  });
  const [psid, setPsNo] = useState("");
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);
  const [showEmployeeTable, setShowEmployeeTable] = useState(true);

  const [roleDetails, setRoleDetails] = useState({
    psid: "",
    role: "",
    appName: "",
  });


  const getRole = async (psid: string) => {
    try {
      const appName = "product-IT";
      const res = await getRoleApi(psid, appName);

      if (res && res.role) {
        const { role, appName } = res.role;
        // console.log("Fetched role:", role);
        setCurrRole(role);
        setRoleDetails({ psid, role, appName });
        return role;
      } else {
        // No role found, set roleDetails with default appName
        setRoleDetails({ psid, role: "", appName: "product-IT" });
        setCurrRole("No Role");
        return "No Role";
      }

    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          if (error.response.data.message === "PS Number not found") {
            // Handle the case where PS Number is not found
            setRoleDetails({ psid, role: "", appName: "product-IT" });
            setCurrRole("No Role");
            return "No Role";
          } else {
            console.log("Response data:", error.response.data);
          }
        } else if (error.request) {
          console.log("Request data:", error.request);
        } else {
          console.log("Error message:", error.message);
        }
      } else {
        console.log("Unexpected error:", error);
      }
      return "No Role";
    }
  };

  useEffect(() => {
    if (psid.length > 0) {
      getRole(psid);
    } else {
      setCurrRole("No Role");
      setRoleDetails({ psid: "", role: "", appName: "product-IT" });
    }
  }, [psid]);

  useEffect(() => {
    setIsSaveDisabled(updateRole.role === "" || roleDetails.role === currRole);
  }, [roleDetails, currRole]);

  const fetchSuggestions = async (search: string) => {
    if (!search) return;
    try {
      const res = await fetchSuggestionsApi(search);
      console.log("response",res);
      setSuggestions(res);
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    }
  };
  // Debounce function
  const debounce = (func: Function, delay: number) => {
    let debounceTimer: NodeJS.Timeout;
    return function(this: any, ...args: any[]) {
      const context = this;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delay);
    };
  };

  const debouncedFetchSuggestions = useCallback(
    debounce((value: string) => fetchSuggestions(value), 500),
    []
  );

  const handleChange = (value: string) => {
    setInput(value);
    setFlag(true);
    setSuggestions([]);
    setShowDetails(false);
    setCurrRole("No Role");
    setUpdateRole({ psid: "", role: "" });
    setRoleDetails({ psid: "", role: "", appName: "" });

    // fetchSuggestions(value);
    // if (value == "") {
    //   setFlag(false);
    // }
    debouncedFetchSuggestions(value);
    if (value === "") {
      setFlag(false);
    }
  };

  const handleUpdateRole = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setUpdateRole({ ...updateRole, [name]: value, psid: psid });
    setRoleDetails({ ...roleDetails, [name]: value, psid });
  };
  const handleOnClick = async (value: any) => {
    setFlag(true);
    setSelectedDetails(value);
    setPsNo(value.psno);
    setShowDetails(true);
    setInput("");
    setSuggestions([]);
    setLoading(false);
    setShowEmployeeTable(false);
    const role = await getRole(value.psno);

  // Log all the user details including the role
  // console.log("User details from suggestion:", {
  //   ...value,
  //   role: role,
  // });
  };

  // console.log(selectedList);
  const handleRowClick = (employee: Employee) =>{
    const nameParts = employee.name.split(' ');
    const firstName = nameParts[0];
    const lastName = nameParts.slice(1).join(' ');
    setSelectedDetails({
      psno: employee.psid,
      email: employee.email,
      firstName: firstName,
      lastName: lastName,
    });
      setPsNo(employee.psid);
      setShowDetails(true);
      setShowEmployeeTable(false);
      getRole(employee.psid);
   
  }

  const cancelRole = async()=>{
    setShowEmployeeTable(true);
    setShowDetails(false);
    setInput("");
    setSuggestions([]);
  }
  

  const handleSaveRole = async () => {
    const { psid, role, appName } = roleDetails;
    const fullName = `${selectedList.firstName} ${selectedList.lastName}`;
    console.log(
      "Saving role for PSID:",
      psid,
      "Role:",
      role,
      "AppName:",
      appName
    );

    try {
      if (currRole === "No Role") {
        // Calling POST API for new user
        const newUser = {
          psid,
          firstName: selectedList.firstName,
          lastName: selectedList.lastName,
          email: selectedList.email,
          role,
          appName: "product-IT", // Hardcoded appName
        };
        await createUserApi(newUser);

        setCurrRole(role);
        setRoleDetails({ ...roleDetails, role }); // Update roleDetails state

        toast.success("User created and role assigned successfully");
        setShowEmployeeTable(true);
        setShowDetails(false);
      } else {
        // Calling PUT API for existing user
        const updateRole = {
          psid,
          appName,
          role,
        };
        await updateUserRoleApi(updateRole);

        setCurrRole(role);
        setRoleDetails({ ...roleDetails, role }); // Update roleDetails state
        toast.success("Role updated successfully");
        setShowEmployeeTable(true);
        setShowDetails(false);
        
      }

      await axiosInstance.post(`${process.env.REACT_APP_EMAIL_SERVICE_BASE_URL}/email/ProductIT`, {
        toEmail: selectedList.email,
        subject: "Role Assignment Notification",
        html: `<p>You have been assigned with a role in Product-IT application. You can now access the application. Follow the below link:</p><p><a href="${process.env.REACT_APP_APPLICATION_BASE_URL}">ProductIT</a></p>`,
      });
  
      toast.success("Email notification sent successfully");
    } catch (error) {
      console.log("Error saving the role", error);
      toast.error("Error saving the role");
    }
  };
  const role = ["Admin", "Requester", "NA"]
  return (
    <div className="accessManagementContainer">
      <Navbar />
      <div className="app-pageSize">
        <div className="searchHeader">
          <input
            className="searchBar"
            type="text"
            placeholder="Search..."
            autoCapitalize="words"
            value={input}
            onChange={(e) => handleChange(e.target.value)}
          />
          <img src={require("../../../images/search.png")} alt="" />
        </div>
        {flag && (
          <div className={suggestions.length > 0 ? "showResult" : ""}>
            {suggestions.length > 0 &&
              suggestions.map(
                (result: { name: string; jobtitle: string }, idx) => {
                  return (
                    <div
                      key={idx}
                      style={{
                        display: "grid",
                        cursor: "pointer",
                      }}
                      onClick={() => handleOnClick(result)}
                    >
                      <span> {result.name}</span>
                      <span> {result.jobtitle}</span> <br />
                    </div>
                  );
                }
              )}
          </div>
        )}
        {showEmployeeTable && <EmployeeTable onRowClick={handleRowClick} />}
        {showDetails && (
          <div className="userDetailsContainer">
            <div className="userdetailHeader">User Details</div>

            <div className="userDetails">
              <div className="column">
                <div className="form-content">
                  <label>First Name:</label>
                  <span>{selectedList.firstName}</span>
                </div>
                <div className="form-content">
                  <label>Email ID:</label>
                  <span>{selectedList.email}</span>
                </div>
                <div className="form-content">
                  <label>Current Role:</label>
                  <span>{currRole}</span>
                </div>
              </div>
              <div className="column-2">
                <div className="form-content">
                  <label>Last Name:</label>
                  <span>{selectedList.lastName}</span>
                </div>
                <div className="form-content">
                  <label>PS No:</label>
                  <span>{selectedList.psno}</span>
                </div>
                <div>
                  <div className="form-content">
                    <label>Update Role:</label>
                    <select
                      onChange={handleUpdateRole}
                      name="role"
                      className="options"
                    >
                      <option style={{ display: "none" }}>
                        Select the option
                      </option>
                      {role && role.map((res) => (
                         <option key={res} value={res}>{res}</option>
                         ))}
                    </select>
                  </div>
                  <button
                    className="saveButton"
                    type="button"
                    onClick={handleSaveRole}
                    disabled={isSaveDisabled}
                  >
                    Save
                  </button>
                  <button
                className="cancelButton"
                type="button"
                onClick={cancelRole}>
                  Cancel
                </button>

                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      
    </div>
  );
};

export default AccessManagement;


